<template>
	<button 
		class="favourites-button"
		:class="(inFavourites) ? 'product-remove-from-favourites-btn' : 'product-add-to-favourites-btn'"
		title="Add/Remove Favourite" 
		@click.stop.prevent="clicked"
	>
		<FilledHeartIcon height="20px" v-if="inFavourites"/>
		<UnfilledHeartIcon height="20px" v-else/>
		<span class="favouritesText"><slot/></span>
	</button>
</template>

<script>
import UnfilledHeartIcon from '@/assets/img/heart-unfilled.svg';
import FilledHeartIcon from '@/assets/img/heart-filled.svg';

export default {
	name: "FavouritesButton",
	components: {
		UnfilledHeartIcon,
		FilledHeartIcon
	},
	props: [
		"itemId"
	],
	methods:{
		clicked(){
			if(this.inFavourites){
				this.$store.dispatch("favourites/doDeleteFavourite", this.itemId)
				this.gtmEvent("removeFromFavourites");
			}else{
				this.$store.dispatch("favourites/doAddFavourite", this.itemId)
				this.gtmEvent("addToFavourites");
			}
		},
		gtmEvent(event) {
			this.$gtm.trackEvent({
				event,
				value: this.itemId
			})
		}
	},
	computed:{
		inFavourites(){
			return this.$store.getters['favourites/inFavourites'](this.itemId);
		}
	}
};
</script>

<style lang="scss" scoped>
.favouritesText{
	padding-left:8px;
	color:$CTred;
	font-size:0.8em;
	text-transform: uppercase;
}

.favourites-button {
	border: 0;
	background-color: inherit;
	color: $CTred;
	&:hover {
		text-decoration: underline;
	}
}
</style>
